import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from '../../UI/Card';
import { lessonsApi } from '../../../utils'
import classes from "./LessonDetails.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { throwApiError } from '../../lms-shared/store/error-handling-actions'
import { onKeyDown } from "../../../service";


const LessonDetails = forwardRef(({ setValid, handleChangeBaseProperties, data, studyGroupId, toCParentId, isProfession, prevToCId }, ref) => {
    const texts = useSelector(state => state.translate.texts);
    const uiData = useSelector((state) => state.general.uiData);
    const navigate = useNavigate();
    const location = useLocation();
    const charactersNum = 30
    const descriptionCharactersNum = 60
    const dispatch = useDispatch()

    const [lessonDetailsData, setLessonDetailsData] = useState({
        id: null,
        name: "",
        description: "",
        ideId: null,
    })
    useEffect(() => {
        if (data) {
            if (data.id) {
                setValid(true)
            }
            else {
                if (!lessonDetailsData.name || !lessonDetailsData.ideId) {
                    setValid(false)
                }
                else {
                    setValid(true)
                }
            }
        }
    }, [lessonDetailsData])

    useEffect(() => {
        if (data && data.id && data.ideId) {
            setLessonDetailsData((prevData) => ({ ...prevData, description: data.description, name: data.name, ideId: data.ideId }))
        }
    }, [data])

    const createOrUpdate = (name, description, ideId) => {
        if (data && !data.id) {
            let mydata
            if (isProfession) {
                mydata = {
                    name: name,
                    description: description,
                    courseId: studyGroupId,
                    parentToCId: toCParentId,
                    prevToCId: prevToCId,
                    ideId: ideId ? ideId : 1,
                    active: true,
                    visible: false,
                    isLocked: true
                }
            } else {
                mydata = {
                    name: name,
                    description: description,
                    studyGroupId: studyGroupId,
                    parentToCId: toCParentId,
                    prevToCId: prevToCId,
                    ideId: ideId ? ideId : 1,
                    active: true,
                    visible: false,
                }
            }
            lessonsApi.lessonsAddPost({ lessonAddInput: mydata }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.lessonsAddError, error: error, statusCode: response?.statusCode, message: "lessonsAddPost " + error.message, level: 2, component: "LessonDetails", line: 77 }))
                }
                else {
                    const lessonId = resdata;
                    // save lesson id to reload 
                    const state = { ...location.state, lessonId: lessonId };
                    navigate("", { replace: true, state })
                    handleChangeBaseProperties(name, description, ideId, lessonId)
                }
            })
        } else {
            //update
            let mydata = {
                id: data.id,
                name: name,
                description: description,
                visible: data.visible
            }
            lessonsApi.lessonsUpdatePost({ lessonUpdateInput: mydata }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.lessonsUpdateError, error: error, statusCode: response?.statusCode, message: "lessonsUpdatePost " + error.message, level: 2, component: "LessonDetails", line: 98 }))
                } else {
                    handleChangeBaseProperties(name, description, ideId, data.id)
                }
            })
        }
    }

    useImperativeHandle(ref, () => ({
        async stepNext() {
            createOrUpdate(lessonDetailsData.name, lessonDetailsData.description, lessonDetailsData.ideId)
        }
    }))

    const handleChange = (event) => {
        event.persist();
        if (event.target.name === "lessonName") {
            setLessonDetailsData((prevData) => ({ ...prevData, name: event.target.value, }))
            if (data && data.id) {
                createOrUpdate(event.target.value, lessonDetailsData.description, lessonDetailsData.ideId)
            }
        }
        else if (event.target.name === "description") {
            setLessonDetailsData((prevData) => ({ ...prevData, description: event.target.value, }))
            if (data && data.id) {
                createOrUpdate(lessonDetailsData.name, event.target.value, lessonDetailsData.ideId)
            }
        }
    }

    const setAndHandleChangeIde = (newIdeId) => {
        if (!data.ideId) {
            setLessonDetailsData((prevData) => ({ ...prevData, ideId: newIdeId }))
            if (data.id) {
                createOrUpdate(lessonDetailsData.name, lessonDetailsData.description, newIdeId)
            }
        }
    }
    const debounce = (func, delay) => {
        let debounceTimer;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer =
                setTimeout(() => func.apply(context, args), delay);
        }
    }
    let optimisedHandleChange = debounce(handleChange, 700);

    return (
        <div className={classes.LessonDetailsWrapper}>
            <div className={classes.LessonDetails}>
                <div className={classes.LessonName}>
                    <div className={classes.LessonNameText}>
                        <h2 className={`${classes.Title}`}>{texts.lessonName}</h2>
                        <div className={classes.UpToCharacters}>({texts.upTo} {charactersNum} {texts.characters})</div>
                    </div>
                    <div className={classes.LessonNameInputWrapper}>

                        <input type='text'
                            name="lessonName"
                            className={`${classes.Input} ${classes.LessonNameInput}`}
                            onChange={optimisedHandleChange}
                            maxLength={charactersNum} 
                            // placeholder={lessonDetailsData.name}
                            defaultValue={lessonDetailsData.name}
                        />
                        <div className={classes.CharactersNum}>{lessonDetailsData.name.length}/{charactersNum} {texts.characters}</div>
                    </div>
                </div>
                <div className={classes.Description}>
                    <h2 className={classes.Title}>{texts.description}</h2>
                    <div className={classes.DescriptionInputWrapper}>
                        <input type='text'
                            name="description"
                            className={`${classes.Input} ${classes.DescriptionInput}`}
                            onChange={optimisedHandleChange}
                            maxLength={60} 
                            // placeholder={lessonDetailsData.description} 
                            defaultValue={lessonDetailsData.description}
                        />
                        <div className={classes.CharactersNum}>{lessonDetailsData.description ? lessonDetailsData.description.length : 0}/{descriptionCharactersNum} {texts.characters}</div>
                    </div>
                </div>
                <div className={classes.Ide}>
                    <h2 className={`${classes.Title} ${classes.IdeText}`}>{texts.ide}</h2>
                    <div className={classes.IdesWrap}>
                        {uiData.ides && uiData.ides.map(ide =>
                            <div key={ide.id}
                                className={`${classes.WrapIde} ${ide.id === lessonDetailsData.ideId && classes.WrapIdeSelected}`}
                                onClick={() => setAndHandleChangeIde(ide.id)}
                                tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setAndHandleChangeIde(ide.id))}
                                style={{ cursor: data.ideId ? "not-allowed" : "pointer" }} >
                                <Card>
                                    <div className={classes.Content} >
                                        <div className={classes.ContentImg} style={{ backgroundImage: `url(${ide.backgroundImage}` }}> </div>
                                    </div>
                                </Card>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
})

export default LessonDetails;